import { useSyncExternalStore } from "react";
import { getSession, subscribe } from "./sessionStore";

export function useSession() {
  return useSyncExternalStore(subscribe, getSession, getSession);
}
